import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { ScreenProps } from "./types";

const TransactionDisputeSuccess = ({ state: { accountInfo } }: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="break" size="92" />
    <Text as="h4" textStyle="heading5" textStyle-sm="heading4">
      Your dispute has been submitted.
    </Text>
    <Text>
      We’ll send an email to <strong>{accountInfo.userEmail}</strong> to update
      you on the status of your dispute.
    </Text>
    <Link appearance="primary-button" href="/manage-account" newTab={false}>
      Manage account
    </Link>
  </Stack>
);

export { TransactionDisputeSuccess };
